export let UtmTrackingAttr;

(function (UtmTrackingAttr) {
  UtmTrackingAttr["Id"] = "utm_id";
  UtmTrackingAttr["Content"] = "utm_content";
  UtmTrackingAttr["Medium"] = "utm_medium";
  UtmTrackingAttr["Source"] = "utm_source";
  UtmTrackingAttr["Campaign"] = "utm_campaign";
  UtmTrackingAttr["Term"] = "utm_term";
})(UtmTrackingAttr || (UtmTrackingAttr = {}));